module.exports = __webpack_public_path__ + "media/images/fastweb-logo-for-white-bg-92dd51b5.svg";